import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    AnalyticsService,
    ColorService,
    FileDownloadService,
    FileUploadService,
    IconService,
    SettingService,
    StorageService,
    UserService,
} from '@services';

const SHARED_SERVICES = [
    AnalyticsService,
    FileDownloadService,
    FileUploadService,
    IconService,
    SettingService,
    StorageService,
    UserService,
    ColorService,
];

@NgModule()
export class BaseModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: BaseModule,
            providers: [
                ...SHARED_SERVICES,
            ],
        };
    }
}
